import { useMemo } from 'react';

import type { DraftWorkItem } from '../controllers/use-ai-create-project-context/types';

import { useStableArray } from './useStableArray';

export function useUniqueIssueTypeIds(items: DraftWorkItem[]): Set<string> {
	function extractIssueTypeIds(items_: typeof items): string[] {
		return items_.flatMap((item: (typeof items)[number]) => [
			item.issueTypeId,
			...(item.childWorkItems ? extractIssueTypeIds(item.childWorkItems) : []),
		]);
	}

	const uniqueIssueTypeIdsArray = useStableArray(extractIssueTypeIds(items), {
		sort: true,
		deduplicate: true,
	});

	return useMemo(() => {
		return new Set(uniqueIssueTypeIdsArray);
	}, [uniqueIssueTypeIdsArray]);
}
